import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-sun.tsx
/**
* icon.24.sun
*
* Keywords: brightness, light, settings, control, adjustment, display, radiance, illumination
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTIgNWEuNS41IDAgMCAxIC41LjV2MWEuNS41IDAgMCAxLTEgMHYtMUEuNS41IDAgMCAxIDEyIDVtNCA3YTQgNCAwIDEgMS04IDAgNCA0IDAgMCAxIDggMG0tNCAzYTMgMyAwIDEgMCAwLTYgMyAzIDAgMCAwIDAgNk03Ljc1NyA3LjA1YS41LjUgMCAxIDAtLjcwNy43MDdsLjcwNy43MDdhLjUuNSAwIDAgMCAuNzA3LS43MDd6TTE5IDEyYS41LjUgMCAwIDEtLjUuNWgtMWEuNS41IDAgMCAxIDAtMWgxYS41LjUgMCAwIDEgLjUuNW0tMi4wNS00LjI0M2EuNS41IDAgMSAwLS43MDctLjcwN2wtLjcwNy43MDdhLjUuNSAwIDAgMCAuNzA3LjcwN3pNMTIgMTdhLjUuNSAwIDAgMSAuNS41djFhLjUuNSAwIDAgMS0xIDB2LTFhLjUuNSAwIDAgMSAuNS0uNW00LjI0Mi0xLjQ2NGEuNS41IDAgMSAwLS43MDcuNzA3bC43MDcuNzA3YS41LjUgMCAxIDAgLjcwNy0uNzA3ek03IDEyYS41LjUgMCAwIDEtLjUuNWgtMWEuNS41IDAgMCAxIDAtMWgxYS41LjUgMCAwIDEgLjUuNW0xLjQ2NSA0LjI0M2EuNS41IDAgMSAwLS43MDctLjcwN2wtLjcwNy43MDdhLjUuNSAwIDAgMCAuNzA3LjcwN3oiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-2372
*/
const Icon24Sun = memo(function Icon24Sun(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M12 5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 12 5m4 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-4 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6M7.757 7.05a.5.5 0 1 0-.707.707l.707.707a.5.5 0 0 0 .707-.707zM19 12a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .5.5m-2.05-4.243a.5.5 0 1 0-.707-.707l-.707.707a.5.5 0 0 0 .707.707zM12 17a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5m4.242-1.464a.5.5 0 1 0-.707.707l.707.707a.5.5 0 1 0 .707-.707zM7 12a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .5.5m1.465 4.243a.5.5 0 1 0-.707-.707l-.707.707a.5.5 0 0 0 .707.707z",
			clipRule: "evenodd"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M11.5 5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5m3.5 6.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M11.5 14a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m4.596-6.39a.5.5 0 1 0-.707-.706l-.707.707a.5.5 0 1 0 .707.707zM18 11.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .5.5m-2.61 4.596a.5.5 0 1 0 .706-.707l-.707-.707a.5.5 0 1 0-.707.707zM11.5 16a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5m-3.182-.61a.5.5 0 1 0-.707-.708l-.707.707a.5.5 0 1 0 .707.707zM7 11.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 .5.5m.61-3.182a.5.5 0 0 0 .708-.707l-.707-.707a.5.5 0 1 0-.707.707z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Sun };

//# sourceMappingURL=icon-24-sun.js.map